import { Directive, forwardRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { RestrictedValidatorFn } from './restricted-validator.fn';
@Directive({
  selector:
    '[restricted][formControlName],[restricted][formControl],[restricted][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RestrictedDirective),
      multi: true
    }
  ]
})
export class RestrictedDirective implements Validator {
  @Input() restricted:string[] = [];
  validate: (targetCtrl: AbstractControl) => { [key: string]: any } = (targetCtrl)=>{
    return RestrictedValidatorFn(targetCtrl, this.restricted);
  }  
}
